import React from 'react';
import $ from 'jquery';
import Overlay from './Overlay';
import idgen from 'app/lib/idgen';

class OverlayTrigger extends Overlay {

    static propTypes = {
        /**
         *
         */
        overlay: React.PropTypes.node
    };

    /**
     * I.E. 10 Fix: Otherwise, Overlay has no 'container' prop
     */
    static defaultProps = {
        container: {
            findDOMNode: function findDOMNode() {
                return document.body;
            }
        }
    };

    constructor(props) {
        super(props);
        this.state = {isOverlayShown: false};
        this.showOverlay = this.showOverlay.bind(this);
        this.renderOverlay = this.renderOverlay.bind(this);
        this.overlayID = `overlay_${idgen()}`;
    }

    render() {
        let {overlay, children, ...props} = this.props;
        let child = React.Children.only(children);
        return React.cloneElement(
            child,
            {onClick: this.showOverlay}
        );
    }

    renderOverlay() {
        return React.cloneElement(this.props.overlay, {onRequestHide: this.toggle, id: this.overlayID});
    }

    showOverlay() {
        $('#' + this.overlayID).openModal();
    }
}


export default OverlayTrigger;
